const BASE = "/api";

export const API_BASE = BASE;

export async function postJSON(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Não foi possível enviar. Tente novamente.");
  }
  return res.json();
}

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
  });
  if (res.status === 401 || res.status === 403) {
    if (typeof window !== "undefined") window.dispatchEvent(new Event("mat-auth-expired"));
    throw new Error("Sessão expirada. Faça login novamente.");
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Ocorreu um erro.");
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res;
}

export async function getJSON(path) {
  const res = await fetch(`${BASE}${path}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Erro ao carregar.");
  }
  return res.json();
}

export async function logoutRequest() {
  try { await fetch(`${BASE}/auth/logout`, { method: "POST", credentials: "include" }); } catch { /* ignore */ }
}

// ---------- End-user account helpers (cookie mat_user) ----------
export async function accountGet(path) {
  const res = await fetch(`${BASE}${path}`, { credentials: "include" });
  if (res.status === 401 || res.status === 403) return null;
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Ocorreu um erro.");
  }
  return res.json();
}

export async function accountSend(path, method, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Ocorreu um erro. Tente novamente.");
  }
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res;
}
